export default {
  en: {
    'coins': 'coins',
    'exchange_completed': 'Exchange completed.',
    'exchange': 'exchange',
    'buy_coins': 'buy coins',
    'you_purchased_x_coins': 'You purchased {coins} coins!',
    'you_exchanged_x_coins_for_y_currency': 'You exchanged {coins} coins for {balanceGain} of {type} action points!',
    'exchange_coins': 'exchange coins',
    'action_points_negotiation': 'action points negotiation',
    'action_points_scouting': 'action points scouting',
    'action_points_training_gk': 'action points training gk',
    'action_points_training_df': 'action points training df',
    'action_points_training_mf': 'action points training mf',
    'action_points_training_at': 'action points training at',
    'currency': 'currency',
    '': '',
  }
};
